import React from "react" ;
import Layout from '../components/UI/Layout/Layout';
 import 'bootstrap/dist/css/bootstrap.min.css';
export default () => (<Layout/>)
